<template>
  <div>
    <b-modal
      :id="`modal-action-${action}`"
      :ref="`modal-action-${action}`"
      :title="`${title} documento`"
      :ok-title="title"
      no-close-on-backdrop
      cancel-title="Cancelar"
      @ok="commitAction"
      :ok-disabled="loading"
      @cancel="cancelProcess"
      size="sm"
    >
      <b-overlay :show="loading">
        <div class="mt-2">
        <form
          autocomplete="off"
          data-vv-scope="sign-document"
          class="d-flex justify-content-center"
          v-on:submit.prevent
        >
          <div class="row">
            <vs-select
              class="col-12 mb-2"
              autocomplete
              label="Seleccione tipo de Firma"
              v-model="signType"
            >
              <vs-select-item
                :value="firma"
                :text="providerName(firma.proveedor)"
                v-for="firma in userSignConfiguration.userSigns"
                :key="firma.id"
              />
            </vs-select>
            <vs-input
              v-if="signerProviderConfig.otp"
              autocomplete="off"
              class="col-12 mb-2"
              label="Código OTP"
              maxlength="6"
              name="otp"
              v-model="otpCode"
              v-validate="'required'"
              :danger="errors.has('sign-document.otp')"
              :danger-text="errors.first('sign-document.otp')"
            />
            <vs-input
              autocomplete="off"
              v-if="signerProviderConfig.password"
              class="col-12"
              type="password"
              label="Contraseña de certificado"
              name="certificatePassword"
              v-model="certificatePassword"
              v-validate="'required|min:6'"
              :danger="errors.has('sign-document.certificatePassword')"
              :danger-text="errors.first('sign-document.certificatePassword')"
            />
          </div>
        </form>
      </div>
      </b-overlay>
    </b-modal>
    <b-modal
      :id="`modal-action-${action}-agile`"
      :ref="`modal-action-${action}-agile`"
      :title="`${title} documento`"
      :ok-title="title"
      no-close-on-backdrop
      cancel-title="Cancelar"
      @ok="commitActionAgile"
      @cancel="cancelProcess"
      size="sm"
    >
      <b-overlay :show="loading">
        <form
        autocomplete="off"
        data-vv-scope="sign-document-agile"
        class="d-flex justify-content-center"
        v-on:submit.prevent
      >
        <div class="container">
          <div class="row">
            <div class="col-12">
              <p>
                Se ha enviado un código de seguridad a tu dirección de correo electrónico.
                Por favor, revisa tu bandeja de entrada.
                El correo contendrá un código de seguridad único
                que deberás ingresar para completar el proceso de registro.
              </p>
              <p>
                Si no encuentras el correo electrónico en tu bandeja de entrada,
                te recomendamos verificar la carpeta de correo no deseado (spam).
              </p>
              <p>
                Recuerda que el código de seguridad es personal y confidencial.
                No lo compartas con nadie y asegúrate de ingresarlo correctamente.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <input
                  class="form-control"
                  v-model="otpCode"
                  v-validate="'required'"
                  placeholder="Ingresar código que se envió a su correo"
                >
              </div>
            </div>
          </div>
        </div>
      </form>
      </b-overlay>
    </b-modal>
    <b-modal
      :id="`modal-action-${action}-external-otp`"
      :ref="`modal-action-${action}-external-otp`"
      :title="`${title} documento`"
      :ok-title="title"
      no-close-on-backdrop
      cancel-title="Cancelar"
      @ok="commitExternalOtp"
      @cancel="cancelProcess"
    >
      <b-overlay :show="loading">
        <form
        autocomplete="off"
        data-vv-scope="sign-external-otp"
        class="d-flex justify-content-center"
        v-on:submit.prevent
      >
        <div class="container">
          <div class="row mt-3">
            <div class="col-12">
              <p>
                Se ha enviado un código de seguridad a tu dirección de correo electrónico.
                Por favor, revisa tu bandeja de entrada.
                El correo contendrá un código de seguridad único
                que deberás ingresar para completar el proceso de registro.
              </p>
              <p>
                Si no encuentras el correo electrónico en tu bandeja de entrada,
                te recomendamos verificar la carpeta de correo no deseado (spam).
              </p>
              <p>
                Recuerda que el código de seguridad es personal y confidencial.
                No lo compartas con nadie y asegúrate de ingresarlo correctamente.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group d-flex justify-content-center">
                <OtpInput
                  v-model="otpCode"
                  @complete="commitExternalOtp"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
      </b-overlay>
    </b-modal>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import { BModal, VBModal, VBToggle } from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { uuid } from 'vue-uuid';

import { signerProviderConfigs } from '@/febos/chile/approvals/components/trays/managementTray/constants';
import Base64Mixin from '@/febos/global/_vue/mixins/Base64Mixin';
import OtpInput from '@/components/inputs/OtpInput';

export default {
  components: {
    BModal,
    OtpInput
  },
  mixins: [Base64Mixin],
  data() {
    return {
      loading: false,
      error: {
        message: ''
      },
      otpCode: '',
      signType: '',
      certificatePassword: '',
      signerProviderConfigs,
      signerProviderConfig: {},
      meta: {},
      metadata: {}
    };
  },
  watch: {
    signType(sign) {
      this.$emit('selectedSign', sign);
      this.configActiveSigner();
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'userSignConfiguration'
    ]),
    providerName() {
      return (provider) => this.signerProviderConfigs[provider]?.description || provider;
    },
    redirectOnSignEnd() {
      const isSignApi = this.signType.proveedor === signerProviderConfigs.ASignAPI.key;
      const noRedirectProviders = [
        signerProviderConfigs.SAgile.key,
        signerProviderConfigs.ASignAPI.key,
        signerProviderConfigs.S_SignAPI_E.key
      ];
      if (isSignApi && this.signerProviderConfig.otp) {
        return true;
      }
      const provider = this.signType.proveedor;
      if (noRedirectProviders.includes(provider)) {
        return false;
      }
      return true;
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'processFileFlow',
      'signFileFlow'
    ]),
    cancelProcess() {
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async signDocument() {
      const isValid = await this.validateForm('sign-document');
      if (!isValid) {
        return;
      }
      this.meta = {};
      const sign = this.getSign();
      if (this.signerProviderConfig.coordenadas) {
        if (!(sign.y >= 0 && sign.x >= 0)) {
          this.$bvToast.toast(
            'No has colocado la ubicación de la estampa',
            {
              title: '¡Oops!',
              variant: 'warning',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 4000,
            }
          );
          return;
        }
      }
      this.loading = true;
      const body = {
        pasoId: this.stepId.id,
        ejecucionId: this.$route.params.flowId,
        aprobacionId: this.$route.params.fileId,
        documentoId: uuid.v1(),
        codigoAutenticador: this.otpCode,
        password: this.certificatePassword,
        tipoFirma: this.signType.tipo,
        idDigitalFirma: this.signType.id,
        OTP: this.otpCode,
        paginaFirma: sign.page,
        // eslint-disable-next-line radix
        coordenadaY: Math.floor(sign.y),
        coordenadaX: Math.floor(sign.x)
      };
      if (this.signType.proveedor === signerProviderConfigs.FirmadorMinisterioEconomia.key) {
        delete body.coordenadaY;
        delete body.coordenadaX;
        delete body.paginaFirma;
      }
      if (!this.redirectOnSignEnd) {
        body.noRedirectOnEnd = true;
      }

      if (this.newFlow) {
        const newFlowAttachments = this.newFlow.adjuntos.filter((fileAt) => fileAt.seleccionado);
        const bodyNewFlow = {
          pasos: this.newFlow.pasos,
          documentos: this.newFlow.documentos,
          adjuntos: newFlowAttachments,
          aprobacionesReferenciaId: this.newFlow.aprobacionesReferenciaId
        };
        if (this.newFlow.processConsequence) {
          const metaFlow = {};
          metaFlow.idGatillador = this.newFlow.processConsequence && this.newFlow.processConsequence.aprobacionesGatilladorProcesoId;
          metaFlow.gatillacionFlujo = bodyNewFlow && this.encode(JSON.stringify(bodyNewFlow));
          metaFlow.gatillacion = {
            ...this.newFlow.processConsequence,
            configuracion: this.newFlow.processConsequence && this.encode(JSON.stringify(this.newFlow.processConsequence)),
          };
          body.meta = {
            ...body.meta,
            ...metaFlow
          };
        }
      }
      let response;
      try {
        response = await this.signFileFlow(body);
        this.loading = false;
        if (this.signType.proveedor === signerProviderConfigs.SAgile.key) {
          this.otpCode = '';
          this.$refs[`modal-action-${this.action}-agile`].show();
          this.meta.challegeId = response.meta.challegeId;
          this.meta.transaccionId = response.meta.transaccionId;
          this.meta.validacionCode = response.meta.transaccionId;
        } else if (this.signType.proveedor === signerProviderConfigs.ASignAPI.key && response.meta) {
          this.otpCode = '';
          this.meta = {
            ...this.meta,
            ...response.meta
          };
          this.$refs[`modal-action-${this.action}-external-otp`].show();
        } else if (this.signType.proveedor === signerProviderConfigs.S_SignAPI_E.key && response.meta && response.meta.otpId) {
          this.otpCode = '';
          this.meta = {
            ...this.meta,
            otpId: response.meta.otpId
          };
          this.$refs[`modal-action-${this.action}-external-otp`].show();
        } else {
          this.$bvToast.toast(
            `${response.mensaje}`,
            {
              title: '¡Genial!',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              noAutoHide: true
            }
          );
        }
      } catch (e) {
        this.loading = false;
        console.log('error', e);
      }
    },
    async signDocumentAgile() {
      const isValid = await this.validateForm('sign-document-agile');
      if (!isValid) {
        return;
      }
      const sign = this.getSign();
      const body = {
        pasoId: this.stepId.id,
        ejecucionId: this.$route.params.flowId,
        aprobacionId: this.$route.params.fileId,
        documentoId: uuid.v1(),
        codigoAutenticador: this.otpCode,
        password: this.certificatePassword,
        tipoFirma: this.signType.tipo,
        idDigitalFirma: this.signType.id,
        OTP: this.otpCode,
        paginaFirma: sign.page,
        // eslint-disable-next-line radix
        coordenadaY: parseInt(sign.y),
        coordenadaX: sign.x,
        meta: this.meta
      };

      if (this.newFlow) {
        const newFlowAttachments = this.newFlow.adjuntos.filter((fileAt) => fileAt.seleccionado);
        const bodyNewFlow = {
          pasos: this.newFlow.pasos,
          documentos: this.newFlow.documentos,
          adjuntos: newFlowAttachments,
          aprobacionesReferenciaId: this.newFlow.aprobacionesReferenciaId
        };
        if (this.newFlow.processConsequence) {
          const metaFlow = {};
          metaFlow.idGatillador = this.newFlow.processConsequence && this.newFlow.processConsequence.aprobacionesGatilladorProcesoId;
          metaFlow.gatillacionFlujo = bodyNewFlow && this.encode(JSON.stringify(bodyNewFlow));
          metaFlow.gatillacion = {
            ...this.newFlow.processConsequence,
            configuracion: this.newFlow.processConsequence && this.encode(JSON.stringify(this.newFlow.processConsequence)),
          };
          body.meta = {
            ...body.meta,
            ...metaFlow
          };
        }
      }
      this.loading = true;
      try {
        const response = await this.signFileFlow(body);
        this.loading = false;
        this.$bvToast.toast(
          `${response.mensaje}`,
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      } catch (e) {
        this.loading = false;
        console.log('er', e);
      }
    },
    async signDocumentExternalOtp() {
      const isValid = await this.validateForm('sign-external-otp');
      if (!isValid) {
        return;
      }
      const sign = this.getSign();
      const body = {
        pasoId: this.stepId.id,
        ejecucionId: this.$route.params.flowId,
        aprobacionId: this.$route.params.fileId,
        documentoId: uuid.v1(),
        codigoAutenticador: this.otpCode,
        password: this.certificatePassword,
        tipoFirma: this.signType.tipo,
        idDigitalFirma: this.signType.id,
        OTP: this.otpCode,
        paginaFirma: sign.page,
        // eslint-disable-next-line radix
        coordenadaY: parseInt(sign.y),
        coordenadaX: sign.x,
        meta: {
          ...this.meta,
          OTP: this.otpCode,
          otpCode: this.otpCode
        }
      };

      if (this.newFlow) {
        const newFlowAttachments = this.newFlow.adjuntos.filter((fileAt) => fileAt.seleccionado);
        const bodyNewFlow = {
          pasos: this.newFlow.pasos,
          documentos: this.newFlow.documentos,
          adjuntos: newFlowAttachments,
          aprobacionesReferenciaId: this.newFlow.aprobacionesReferenciaId
        };
        if (this.newFlow.processConsequence) {
          const metaFlow = {};
          metaFlow.idGatillador = this.newFlow.processConsequence && this.newFlow.processConsequence.aprobacionesGatilladorProcesoId;
          metaFlow.gatillacionFlujo = bodyNewFlow && this.encode(JSON.stringify(bodyNewFlow));
          metaFlow.gatillacion = {
            ...this.newFlow.processConsequence,
            configuracion: this.newFlow.processConsequence && this.encode(JSON.stringify(this.newFlow.processConsequence)),
          };
          body.meta = {
            ...body.meta,
            ...metaFlow
          };
        }
      }

      this.loading = true;
      let response;
      try {
        response = await this.signFileFlow(body);
        this.loading = false;
        this.$refs[`modal-action-${this.action}-external-otp`].hide();
        this.$bvToast.toast(
          `${response.mensaje}`,
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      } catch (e) {
        console.log('e', e);
        this.loading = false;
      }
    },
    commitAction(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.signDocument();
    },
    commitActionAgile(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.signDocumentAgile();
    },
    commitExternalOtp(bvModalEvt) {
      console.log('commit external otp');
      bvModalEvt.preventDefault();
      this.signDocumentExternalOtp();
    },
    configActiveSigner() {
      if (this.signType && this.signType.proveedor) {
        this.signerProviderConfig = this.signerProviderConfigs[this.signType.proveedor];
        if (this.signerProviderConfig.configureOnSelect) {
          this.signerProviderConfig.configureOnSelect(this.signType, this.signerProviderConfig);
        }
      } else {
        this.signerProviderConfig = {};
      }
    }
  },
  mounted() {
    this.signerProviderConfig = {};
    this.meta = {};
    const [signSelected] = this.userSignConfiguration.userSigns;
    const segPresSign = this.userSignConfiguration.userSigns.find((sign) => sign.proveedor.includes('Segpres'));
    if (segPresSign) {
      this.signType = segPresSign;
    } else {
      this.signType = signSelected;
    }
  },
  props: {
    action: { type: String, required: true },
    title: { type: String, required: true },
    stepId: { type: Object, required: false },
    getSign: Function,
    numPages: Number,
    newFlow: Object
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
    'b-modal': VBModal
  },
};
</script>
